export default "__VITE_ASSET__BxpBb5vT__"